import React, { Component } from 'react';
import 'react-calendar/dist/Calendar.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import DropDownTable from '../../Shared/DropDownTable';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import UploadFile from '../../Shared/UploadFile';
import Input from '../../Shared/Input';
import '../../../css/MarketPlace/UpdateServiceRequest.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL, utilityBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_REQUEST_ENDPOINT, LOOKUP_ENDPOINT } from '../../../Services/config/apiEndPoints';
import SuccessModal from '../../Shared/SuccessModal';
import { connect } from 'react-redux';
class UpdateServiceRequest extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            PickupLocation: '',
            Destination: '',
            ServiceWindowStartDate: '',
            ServiceWindowEndDate: '',
            RFQClosingDate: '',
            NoofContainers: '',
            SpecialInstructions: '',
            SpecialInstructionstextLimit: 0,
            Commodity: '',
            TruckTypeRequirements: '',
            PaymentTerms: '',
            PaymentTermsdropdown: false,
            PaymentTermsdata: [],
            loaderTime: false,
            PageDisable: false,
            FilePathUpdateReferenceDocuments: '',
            FilePathUpdateReferenceDocumentsName: '',
            uploadFileDisable: false,
            errors: {},
            hasOpenSuccess: false,
            ApiServiceRequestData: [],
            serviceRequestID: 0,
            serviceNameValue: ''
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount = () => {
        const { serviceId, serviceName } = this.props.match.params;
        this.setState({
            serviceRequestID: serviceId,
            serviceNameValue: serviceName
        });
        this.getRequestDetails(serviceId);
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    getRequestDetails = (serviceRequestId) => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_REQUEST_ENDPOINT + `?roleType=${this.props.manageProfileDataR?.selectedProfileType}&serviceRequestId=${serviceRequestId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log("in 500");
                }
                else {
                    console.log('I am 200!');
                    this.setState({ ApiServiceRequestData: data });
                    console.log("dataFromAPI", this.state.ApiServiceRequestData);
                    this.setState({
                        PickupLocation: this.state.ApiServiceRequestData?.serviceRequestData?.pickup_location,
                        Destination: this.state.ApiServiceRequestData?.serviceRequestData?.destination,
                        ServiceWindowStartDate: FormatTimeStamp(this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.startDateTime).timedateToLocale,
                        ServiceWindowEndDate: FormatTimeStamp(this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.endDateTime).timedateToLocale,
                        NoofContainers: this.state.ApiServiceRequestData?.serviceRequestData?.container_size,
                        Commodity: this.state.ApiServiceRequestData?.serviceRequestData?.commodity,
                        TruckTypeRequirements: this.state.ApiServiceRequestData?.serviceRequestData?.truck_type_req,
                        PaymentTerms: this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.paymentTerm,
                        RFQClosingDate: FormatTimeStamp(this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.rfqDateTime).timedateToLocale,
                        SpecialInstructions: this.state.ApiServiceRequestData?.serviceRequestData?.special_instructions
                    });
                    if (data?.serviceRequestData?.upload_documents) {
                        this.setState({
                            FilePathUpdateReferenceDocuments: data?.serviceRequestData?.upload_documents,
                            FilePathUpdateReferenceDocumentsName: data?.serviceRequestData?.upload_documents?.split('/')[11].split("'")[0],
                            uploadFileDisable: data?.serviceRequestData?.upload_documents?.length > 0 ? true : false
                        })
                    }
                }
            }
        });
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ PaymentTermsdropdown: false });
        }
    };
    onCloseModal = () => {
        this.setState({ hasOpenSuccess: false });
        this.props.history.push({
            pathname: `/TransportationService/${this.state.serviceRequestID}/${this.state.serviceNameValue}`
        });
    };
    handleChangeSpecialInstructions = (e) => {
        if (e.target.value.length <= 180) {
            this.setState({ SpecialInstructionstextLimit: e.target.value.length });
            this.setState({ SpecialInstructions: e.target.value });
            this.setState({
                errors: {
                    ...this.state.errors,
                    SpecialInstructions: ''
                }
            });
            document.getElementsByName('SpecialInstructions')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    toggleDropdownPaymentTerms = () => {
        this.setState({ PaymentTermsdropdown: !this.state.PaymentTermsdropdown }, () => {
            if (this.state.PaymentTermsdropdown) {
                this.fetchDropDownData();
            }
        });
    };
    fetchDropDownData = (index) => {
        var lookupType = "F_PAYMENT_TERMS";
        console.log("type-", lookupType)
        ApiCall(
            'GET',
            utilityBaseURL + LOOKUP_ENDPOINT + `?lookupType=${lookupType}`,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    this.setState({ PaymentTermsdata: data })
                }
            }
            else {
                console.log('something went wrong');
            }
        })
    }
    changeRoleTypePaymentTerms = (event) => {
        const found = this.state.PaymentTermsdata.find((name) => {
            if (name?.lookupCode === event.target.innerText) {
                return name
            }
        })
        this.setState({ PaymentTerms: found?.lookupCode });
        this.setState({ PaymentTermsdropdown: !this.state.PaymentTermsdropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                PaymentTerms: ''
            }
        });
        document.getElementsByName('PaymentTerms')[0].style.borderColor = ColorCode.colorCode.black;
    }
    getDateFormated = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    uploadFileFunction = (uploadConfirm) => {
    }
    removeUpdateReferenceDocumentsLink = () => {
        let path = "";
        this.setState({ FilePathUpdateReferenceDocuments: path, FilePathUpdateReferenceDocumentsName: path });
    }
    setLoaderUpdateReferenceDocuments = (filePathURL) => {
        this.setState({ loaderTime: filePathURL });
        this.setState({ PageDisable: filePathURL });
    }
    setUploadLinkUpdateReferenceDocuments = (filePathURL) => {
        // for loader end
        this.setState({ FilePathUpdateReferenceDocuments: filePathURL });
        this.setState({ FilePathUpdateReferenceDocumentsName: filePathURL?.split('/')[11].split("'")[0] });
        this.setState({ loaderTime: false, PageDisable: false });
    }
    getContainerDetails = () => {
        this.props.history.push({
            pathname: `/QuotationContainerDetails/${this.state.NoofContainers}`
        })
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (!this.state.PaymentTerms) {
            formIsValid = false;
            errors["PaymentTerms"] = Message.validation.required;
            document.getElementsByName('PaymentTerms')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('PaymentTerms')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleContinue = () => {
        if (this.handleValidation()) {
            const obj = {
                pickup_location: this.state.PickupLocation,
                destination: this.state.Destination,
                container_size: this.state.NoofContainers,
                commodity: this.state.Commodity,
                truck_type_req: this.state.TruckTypeRequirements,
               // payment_terms: this.state.PaymentTerms,
                special_instructions: this.state.SpecialInstructions,
                upload_documents: this.state.FilePathUpdateReferenceDocuments
            };
            ApiCall(
                'PUT',
                serviceBaseURL + SERVICE_REQUEST_ENDPOINT,
                {
                    "requestData": {
                        "baseService": {
                            "endDateTime": this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.endDateTime,
                            "location": "",
                            "publishDateTime": new Date().getTime(),
                            "requestorCompanyName": "",
                            "rfqDateTime": this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.rfqDateTime,
                            "serviceId": this.state.serviceRequestID,
                            "serviceName": this.state.serviceNameValue,
                            "serviceType": this.state.serviceNameValue,
                            "startDateTime": this.state.ApiServiceRequestData?.requestSummary?.serviceDetail?.startDateTime,
                            "status": "Open",
                            "paymentTerm": this.state.PaymentTerms
                        },
                        "fieldsData": obj,
                        "docPath": this.state.FilePathUpdateReferenceDocuments
                    },
                    "serviceRequestId": this.state.serviceRequestID
                },
                {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            ).then(data => {
                if (data.flag != -1) {
                    if (data.flag == '500') {
                        console.log('I am 500!');
                    } else {
                        console.log('I am 200!');
                        this.setState({ hasOpenSuccess: true });
                    }
                }
                else {
                    console.log('Something went wrong!');
                }
            });
        }
    }
    render() {
        return (
            <div class="UpdateServiceROutercolor">
                <MetaDecorator title={TitleDescription.UpdateServiceRequestTitle} description={TitleDescription.UpdateServiceRequestDescription} />
                <Header tilesFetched={() => { }} />
                <div class="UpdateServiceROuterDivcss">
                    <div id="UpdateServiceRBoxDiv">
                        <nav class="UpdateServiceRNavbar">
                            <div className="UpdateServiceRNavbarName">
                                <small id="UpdateServiceRNavbarText">Update Service Request</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="UpdateServiceRMidPartition">
                            <div class="UpdateServiceRHeadingText">Service Request Details</div>
                            <div class="UpdateServiceRCardcss">
                                <div class="UpdateServiceRInpSize">
                                    <small id="UpdateServiceRInpHeading">Pickup Location</small>
                                    <div class="UpdateServiceRLowerText">{this.state.PickupLocation}</div>
                                </div>
                                <div class="UpdateServiceRInpSize">
                                    <small id="UpdateServiceRInpHeading">Destination</small>
                                    <div class="UpdateServiceRLowerText">{this.state.Destination}</div>
                                </div>
                                <div class="UpdateServiceRInpSize">
                                    <small id="UpdateServiceRInpHeading">Service Window Start Date & Time</small>
                                    <div class="UpdateServiceRLowerText">{this.state.ServiceWindowStartDate}</div>
                                </div>
                                <div class="UpdateServiceRInpSize">
                                    <small id="UpdateServiceRInpHeading">Service Window End Date & Time</small>
                                    <div class="UpdateServiceRLowerText">{this.state.ServiceWindowEndDate}</div>
                                </div>
                                <div class="UpdateServiceRInpSize">
                                    <small id="UpdateServiceRInpHeading">No. of Containers</small>
                                    <div class="UpdateServiceRLowerText">{this.state.NoofContainers}</div>
                                    <small class="UpdateServiceRInpHeading">
                                        <small class="UpdateServiceContainerRed" onClick={this.getContainerDetails}>Click Here</small> to visit Container Details</small>
                                </div>
                                <div class="UpdateServiceRInpSize">
                                    <small id="UpdateServiceRInpHeading">Commodity</small>
                                    <div class="UpdateServiceRLowerText">{this.state.Commodity}</div>
                                </div>
                                <div class="UpdateServiceRInpSize">
                                    <small id="UpdateServiceRInpHeading">Truck Type Requirements</small>
                                    <div class="UpdateServiceRLowerText">{this.state.TruckTypeRequirements}</div>
                                </div>
                                <div class="UpdateServiceRInpSize">
                                    <small id="UpdateServiceRInpHeading">Payment Terms</small>
                                    <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                        <Input
                                            readOnly name="PaymentTerms" class="input" placeholder="Select Payment Terms"
                                            type="text" id={this.state.PaymentTermsdropdown ? "UpdateServiceRBtmBorderLessCss" : "UpdateServiceRInpDropCss"}
                                            value={this.state.PaymentTerms}
                                        />
                                        <div className="UpdateServiceRDropError">{this.state.errors["PaymentTerms"]}</div>
                                        <i id="UpdateServiceRInp_imgDrop" onClick={this.toggleDropdownPaymentTerms}>
                                            {this.state.PaymentTermsdropdown ? <img src={uparrow} /> : <img src={downarrow} />}
                                        </i>
                                    </div>
                                    {this.state.PaymentTermsdropdown && (
                                        <div class="UpdateServiceRDropDowmDiv" >
                                            <div class="UpdateServiceRDropCard" ref={this.container} >
                                                {(this.state.PaymentTermsdata.map((name, index) => {
                                                    return (
                                                        <DropDownTable onClick={(val) => this.changeRoleTypePaymentTerms(val)} id="UpdateServiceRDropRowSize">
                                                            <small class="" id="UpdateServiceRDropRowText" >{name?.lookupCode} </small>
                                                        </DropDownTable>
                                                    );
                                                }))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div class="UpdateServiceRInpSize">
                                    <small id="UpdateServiceRInpHeading">Request Closing Date</small>
                                    <div class="UpdateServiceRLowerText">{this.state.RFQClosingDate}</div>
                                </div>
                                <div class="UpdateServiceRTextInpSize">
                                    <small id="UpdateServiceRInpHeading">Special Instructions (Optional)</small>
                                    <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                        <Input
                                            name="SpecialInstructions"
                                            class="input" placeholder="Enter Special Requirements"
                                            type="text" id="UpdateServiceRInpCss" value={this.state.SpecialInstructions}
                                            onChange={this.handleChangeSpecialInstructions}
                                        />
                                        <div className="UpdateServiceRError">{this.state.errors["SpecialInstructions"]}</div>
                                        <small class="UpdateServiceRCommentTextlmt">{this.state.SpecialInstructions?.length}/180</small>
                                    </div>
                                </div>
                                <div class="UpdateServiceRInpSize">
                                    <small id="UpdateServiceRInpHeading">Update Reference Documents (Optional)</small>
                                    <div className="pass-wrapper" id="UpdateServiceRInpDiv" >
                                        {this.state.uploadFileDisable &&
                                            <UploadFile uploaddivid="uploadUpdateReferenceDocuments" idupload="upload"
                                                name="fileupload"
                                                fileType="jpeg, jpg, png, pdf"
                                                setUploadConfirm={this.uploadFileFunction}
                                                removeLink={this.removeUpdateReferenceDocumentsLink}
                                                upload_link="cipcUpload" uploadicon="cipcIcon"
                                                setFileLink={this.setUploadLinkUpdateReferenceDocuments}
                                                setLoader={this.setLoaderUpdateReferenceDocuments}
                                                pdfFileName={'Update_Reference_Documents.'}
                                                isUploadDisabled={this.state.uploadFileDisable}
                                                staticFileName={'Update_Reference_Documents.'}
                                            />
                                        }
                                        {!this.state.uploadFileDisable &&
                                            <UploadFile uploaddivid="uploadUpdateReferenceDocuments" idupload="upload"
                                                name="fileupload"
                                                fileType="jpeg, jpg, png, pdf"
                                                setUploadConfirm={this.uploadFileFunction}
                                                removeLink={this.removeUpdateReferenceDocumentsLink}
                                                upload_link="cipcUpload" uploadicon="cipcIcon"
                                                setFileLink={this.setUploadLinkUpdateReferenceDocuments}
                                                setLoader={this.setLoaderUpdateReferenceDocuments}
                                                pdfFileName={'Update_Reference_Documents.'}
                                                isUploadDisabled={this.state.uploadFileDisable}
                                                staticFileName={'Update_Reference_Documents.'}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div class="UpdateServiceRBtnDiv">
                                <Button class="UpdateServiceRBtnCss" onClick={this.handleContinue}>
                                    <small class="UpdateServiceRBtntext">Continue</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="UpdateServiceRFooterUnfixed">
                    <Footer />
                </div>
                <div class="UpdateServiceRFooterFixed">
                    <Footer2 />
                </div>
                <SuccessModal hasOpen={this.state.hasOpenSuccess} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successRatingdivout">
                            <small class="successRatingdivsm">Your request has been submitted
                            </small>
                            <small class="successRatingdivsm"> successfully.</small>
                        </div>
                    </div>
                </SuccessModal>
            </div >
        );
    }
}
function mapStateToProps(state) {
    return {
        manageProfileDataR: state.manageProfileReducer.data
    }
}
export default connect(mapStateToProps)(UpdateServiceRequest);